export enum LeyendColor {
    "event-aceptada" = 'event-accept',
    "event-pendiente" = 'event-pending',
    "event-cancelada" = 'event-reject',
    "registration-normal" = 'registration-normal',
    "registration-overtime" = 'registration-overtime',
    "registration-short" = 'registration-short'
}